import { useMemo, useState } from 'react'
import { useDataTable } from '@/hooks/useDataTable-hook'
import { getTierStores, getFilteredStoresByStore, getFilteredStoresByDate } from '@/services/ClubPlus/TierService'
import { useQuery } from '@tanstack/react-query'
import { TierColConfigData } from '@/services/ClubPlus/TierColConfig'

export const useTiers = ( tierID, pageSize ) => {
  const firstPageIndex = 1;
  const isNotUtcDate = true;
  const clearSearchArray = true;
  const [clearDateSearch, setClearDateSearch] = useState(false);

  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll} = useDataTable( firstPageIndex, isNotUtcDate, clearSearchArray, clearDateSearch)

  // Determine filter type based on searchArr
  const filterType = useMemo(() => {
    const fields = searchArr.map(item => item.field)
    if (fields.includes('storeId')) return 'store'
    if (fields.includes('displayDate')) return 'date'
    return 'none'
  }, [searchArr])

  // Transform date fields in searchArr to displayDate
  const transformedSearchValue = useMemo(() => {
  if (filterType === 'date') {
    const dateItem = searchArr.find(item => item.type === 'date' && item.value)
    setClearDateSearch(false);
    if (dateItem) {
      return dateItem.value;
    }
  } else if (filterType === 'store') {
    const stringItem = searchArr.find(item => item.type === 'string' && item.value)
    setClearDateSearch(true);
    return stringItem?.value ?? null
  }

  return null
}, [searchArr, filterType])

  // Fetch all stores when no filter is applied
  const {data: allData, isLoading: isAllLoading, refetch: refetchAll} = useQuery({
    queryKey: ['tier-stores', tierID, '', pageIndex, pageSize],
    queryFn: () => getTierStores(tierID, '', pageIndex, pageSize),
  })

  //Filter by store
  const {data: storeData, isLoading: isStoreLoading, refetch: refetchStore} = useQuery({
    queryKey: ['filtering-stores-by-store-id', tierID, transformedSearchValue, pageIndex, pageSize],
    queryFn: () => getFilteredStoresByStore(tierID, transformedSearchValue, pageIndex, pageSize),
    enabled: filterType === 'store' && !!tierID,
  })

  // // Filter by date
  const {data: dateData, isLoading: isDateLoading, refetch: refetchDate} = useQuery({
    queryKey: ['filtering-stores-by-date', tierID, transformedSearchValue, pageIndex, pageSize],
    queryFn: () => getFilteredStoresByDate(tierID, transformedSearchValue, pageIndex, pageSize),
    enabled: filterType === 'date' && !!tierID,
  })

  const getByFilterType = {
    store: {
      data: storeData,
      isLoading: isStoreLoading,
      refetch: refetchStore,
    },
    date: {
      data: dateData,
      isLoading: isDateLoading,
      refetch: refetchDate,
    },
    none: {
      data: allData,
      isLoading: isAllLoading,
      refetch: refetchAll,
    },
  }[filterType]

  const { data, isLoading, refetch } = getByFilterType

  return {
    tiersData: data,
    TierColConfigData: TierColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    searchArr: transformedSearchValue,
    handleResetAll,
    isLoading,
    refetch
  }
}
